var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackChangesBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.667-1.667h29.334v29.334H-1.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.641 4.359l-1.723 1.723A9.795 9.795 0 0122.778 13 9.775 9.775 0 0113 22.778 9.775 9.775 0 013.222 13c0-4.987 3.728-9.093 8.556-9.692v2.469C8.307 6.363 5.667 9.37 5.667 13A7.34 7.34 0 0013 20.333 7.34 7.34 0 0020.333 13a7.265 7.265 0 00-2.15-5.182L16.458 9.54A4.92 4.92 0 0117.889 13 4.888 4.888 0 0113 17.889 4.888 4.888 0 018.111 13c0-2.273 1.565-4.168 3.667-4.718v2.616A2.42 2.42 0 0010.556 13c0 1.344 1.1 2.444 2.444 2.444 1.344 0 2.444-1.1 2.444-2.444 0-.904-.488-1.687-1.222-2.102V.778H13C6.253.778.778 6.253.778 13S6.253 25.222 13 25.222 25.222 19.747 25.222 13c0-3.373-1.369-6.429-3.58-8.641z",
    fill: "#232323",
    fillRule: "nonzero"
  }))));
}
export default SvgTrackChangesBlack24Dp;